import React, { useState } from "react";
import { Button } from "react-bootstrap";
import PolicyAnnouncementFormModal from "./PolicyAnnouncementFormModal";
import PolicyAnnouncementsTable from "./PolicyAnnouncementsTable";
import Modal from "../Modal";

const PolicyAnnouncements = (props) => {
  const [showCreateAnnouncementModal, setShowCreateAnnouncementModal] = useState(false);

  function renderNewPolicyButton() {
    if (props.policyPermissions?.canCreate) {
      return (
        <Button
          className="btn btn-primary mb-3 ml-auto"
          onClick={() => {
            setShowCreateAnnouncementModal(true);
          }}
        >
          + Add New Policy Announcement
        </Button>
      );
    }

    return null;
  }

  return (
    <div>
      <div className="d-flex justify-content-end mb-6">{renderNewPolicyButton()}</div>
      <PolicyAnnouncementsTable
        columns={props.columns}
        policyAnnouncements={props.policyAnnouncements}
        manufacturers={props.manufacturers}
        policyTypes={props.policyTypes}
        envESPAppDomain={props.envESPAppDomain}
        tab={props.tab}
        {...props.policyPermissions}
      />
      <Modal
        show={showCreateAnnouncementModal}
        title={"New Policy Announcement"}
        buttonText="Save Draft"
        buttonType="success"
        modalId="new_announcement_modal"
        disableFooter={true}
        body={
          <PolicyAnnouncementFormModal
            manufacturers={props.manufacturers}
            policyTypes={props.policyTypes}
            action={"create"}
          />
        }
        dismiss={() => {
          setShowCreateAnnouncementModal(false);
        }}
      />
    </div>
  );
};

export default PolicyAnnouncements;
